<template>
  <b-row align-v="center" col="12" class="mb-5" style="background: #bee4e3;">
    <b-col class="pl-5" sm="12" md="12" lg="8" xl="8" style="margin-top: 30px; font-size: 18px; text-align: left">
      <h1 class="text-left title">
        Demján Sándor 1+1 KKV Beruházás-élénkítő Támogatási Program
      </h1>
      <p class="text-left mt-3" style="color: #39455e;">
        A program a hazai tulajdonú, mikro-, kis- és középvállalkozások eszközberuházásait támogatja annak érdekében,
        hogy termelési kapacitásuk fejlődjön, magasabb hozzáadott értékű termékek gyártására nyíljon lehetőség. Egy
        vállalkozás 5-200 millió forint támogatásban részesülhet. A vállalkozás beruházásának 50%-át az állam vissza nem
        térítendő támogatásként biztosítja.
      </p>
      <b-button class="mt-2 link-button" @click="openLink('/egypluszegy-program')">
        Megnézem
      </b-button>
      <b-button class="mt-2 link-button2" @click="openLink('https://dsprogram.hu/demjansandorprogram/')">
        További Demján Sándor Konstrukciók
      </b-button>
    </b-col>
    <b-col class="d-none d-xl-block d-lg-block">
      <!-- Only show this col when on larger devices. -->
      <img src="../assets/img/Demjan_portre.png" style="max-width: 100%;" />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'egypluszegy',
  methods: {
    openLink(url) {
      window.location.href = url
    }
  }
}
</script>

<style scoped>
.link-button {
  width: 270px;
  margin-bottom: 30px;
  margin-right: 70px;
  background-color: #a27e5b !important;
  color: white;
  border: none;
}

.link-button2 {
  width: 350px;
  margin-bottom: 30px;
  background-color: #a27e5b !important;
  color: white;
  border: none;
}

.link-button:hover {
  background-color: #a27e5b !important;
  color: inherit; /* Szöveg színének megőrzése */
}

.link-button2:hover {
  background-color: #a27e5b !important;
  color: inherit;
}

.title {
  color: #39455e;
  font-weight: 600;
  text-align: justify;
  text-justify: inter-word;
}
</style>
